import Row from "./row";
import FeaturesRoot from "./features"
import Item from "./item";
import { ItemBody, ItemTitle } from "./texts";


const FeaturseUI = Object.assign(FeaturesRoot, {
  Row,
  Item,
  ItemBody,
  ItemTitle,
})

export default FeaturseUI
